"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVbucksRedirectURL = exports.generateRouteTo = exports.generateRouteHref = void 0;
const query_string_1 = __importDefault(require("query-string"));
/**
 * generateRouteHref returns a string including URL query parameters to be used in a link
 * @param toOrPath - Path or To object that the link should go to (relative to the root of application)
 * @param location - Location object representing the current location of the app
 * @returns - String of where the link should navigate to - e.g. /crew?lang=fr
 */
function generateRouteHref(toOrPath, location) {
    var _a;
    const to = normalizeTo(toOrPath);
    const queries = constructQueryParams((_a = to.search) !== null && _a !== void 0 ? _a : '', location, ['lang']);
    if (Object.keys(queries).length > 0) {
        return `${to.pathname}?${query_string_1.default.stringify(queries)}`;
    }
    return typeof to === 'string' ? to : to.pathname;
}
exports.generateRouteHref = generateRouteHref;
/**
 * generateRouteTo returns a Location object to be used in a Link
 * @param toOrPath - Path or To object that the link should go to (relative to the root of application)
 * @param location - Location object representing the current location of the app
 * @returns - Location object of where the application should go to - e.g. `{pathname: '/crew', search: '?lang=fr'}'
 */
function generateRouteTo(toOrPath, location) {
    var _a;
    const to = normalizeTo(toOrPath);
    const queries = constructQueryParams((_a = to.search) !== null && _a !== void 0 ? _a : '', location, ['lang']);
    if (Object.keys(queries).length > 0) {
        return {
            pathname: to.pathname,
            search: `?${query_string_1.default.stringify(queries)}`
        };
    }
    return typeof to === 'string' ? { pathname: to } : to;
}
exports.generateRouteTo = generateRouteTo;
function normalizeTo(toOrPath) {
    if (typeof toOrPath === 'string') {
        const path = toOrPath;
        const queryIndex = path.indexOf('?');
        const to = {
            pathname: queryIndex > -1 ? path.slice(0, queryIndex) : path,
            search: queryIndex > -1 ? path.slice(queryIndex) : undefined
        };
        return to;
    }
    return toOrPath;
}
/**
 * constructQueryParams returns the query parameters that should be included as part of a link
 * @param pathQuery - URL query string from the link URL/path
 * @param currentLocation - Location object representing the current loation of the app
 * @param paramsToPropagate - Array of parameter names that should be propagates from current location
 * @returns - Object with the parameters & values
 */
function constructQueryParams(pathQuery, currentLocation, paramsToPropagate) {
    const currentSearch = query_string_1.default.parse(currentLocation.search);
    const pathSearch = pathQuery.length > 0 ? query_string_1.default.parse(pathQuery) : {};
    const queries = pathSearch;
    for (const key of paramsToPropagate) {
        if (currentSearch[key]) {
            queries[key] = currentSearch[key];
        }
    }
    return queries;
}
/**
 * getVbucksRedirectURL constructs a URL string based on the current location search params,
 * filtering parameters to include only vbuckscard query params.
 *
 * @param location - Location object representing the current location of the app.
 * @param additionalQuery - Additional queries not grabbed from location.search (code inputted after).
 * @returns {string} - A string URL composed of the /vbuckscard path + filtered query parameters.
 *
 */
function getVbucksRedirectURL(location, additionalQuery = {}) {
    const locationQuery = query_string_1.default.parse(location.search);
    const mergedQuery = Object.assign(Object.assign({}, locationQuery), additionalQuery);
    const filtered = {};
    const allowedKeys = [
        'code',
        'lang',
        'source',
        'sessionInvalidated',
        'utm_campaign',
        'utm_content',
        'utm_medium',
        'utm_source',
        'utm_term'
    ];
    // Written like so for ES2016 compatibility
    for (const key in mergedQuery) {
        if (Object.prototype.hasOwnProperty.call(mergedQuery, key) && allowedKeys.indexOf(key) !== -1) {
            const val = mergedQuery[key];
            filtered[key] = key === 'code' && typeof val === 'string' ? val.toUpperCase() : val;
        }
    }
    const qsString = query_string_1.default.stringify(filtered);
    return `/vbuckscard${qsString ? `?${qsString}` : ''}`;
}
exports.getVbucksRedirectURL = getVbucksRedirectURL;
//# sourceMappingURL=route.js.map